import React from 'react'
import {withRouter, Link} from "react-router-dom";
import './StockList.scss';
import {MDBBox, MDBIcon, MDBTypography} from "mdbreact";
import {assetUrl, loss_color, profit_color} from "../../serviceApi";

import Reveal from "react-reveal/Reveal";
import Skeleton from "react-loading-skeleton";

const ProfileIcon = assetUrl + "images/profile-icon.svg";
const caretUp = assetUrl + 'images/stocklist-green-arrow-large.png'
const caretDown = assetUrl + 'images/stocklist_red_arrow_large.png'

class StockList extends React.Component {

	render() {
		const {stock_list, stock_owned_count, stock_history_details} = this.props;
		// console.log(stock_list)

		return (
			<MDBBox className="politician-list-component">

				{
					this.props.loading ?<>
					<Skeleton count={3}/>
					<br/><br/>
					<Skeleton count={3}/>
					<br/><br/>
					<Skeleton count={3}/>
					<br/><br/>
					<Skeleton count={3}/>
					<br/><br/>
					</> :
					stock_list.length > 0 ?
						stock_list.map((item, index) => {

							let stockOwnedCount
							let priceDiff
							let priceDiffPercentage
							if (stock_owned_count) {
								for (let i in Object.keys(stock_owned_count)) {
									if (item.id === Object.keys(stock_owned_count)[i]) {
										stockOwnedCount = Object.values(stock_owned_count)[i]
									}
									if (item.node && item.node.id === Object.keys(stock_owned_count)[i]) {
										stockOwnedCount = Object.values(stock_owned_count)[i]
									}
								}
							} else {
								stockOwnedCount = 0
							}

							if (stock_history_details) {
								for (let i in stock_history_details) {
									let stock_history_details_id = stock_history_details[i]
									// console.log(stock_history_details_id)

									if (item.id === stock_history_details_id.stock_id) {
										priceDiff = stock_history_details_id.price_diff !== null ? stock_history_details_id.price_diff : 0
										priceDiffPercentage = stock_history_details_id.price_diff_percentage !== null ? stock_history_details_id.price_diff_percentage : 0
										// console.log("stockhistory",stock_history_details_id.price_diff_percentage)
									}
									if (item.node && item.node.id === stock_history_details_id.stock_id) {
										priceDiff = stock_history_details_id.price_diff !== null ? stock_history_details_id.price_diff : 0
										priceDiffPercentage = stock_history_details_id.price_diff_percentage !== null ? stock_history_details_id.price_diff_percentage : 0
										// console.log("stockhistory",stock_history_details_id.price_diff_percentage)
									}
								}
							}

							return (


									item.id  ?
										<Link to={"/stock-detail/" + (item.id)} key={index}>
											{/*<Reveal effect="zoomIn fadeInUp">*/}
											<MDBBox className="d-flex justify-content-between align-items-center">
												<MDBBox className="d-flex align-items-center">
													<MDBBox className="politician-profile">
														<img
															src={item.politicianImage ? item.politicianImage : ProfileIcon}
															alt="politician1" className="img-fluid"
															style={{
																width: "40px",
																height: "40px",
																objectFit: "contain"
															}}/>
													</MDBBox>
													<MDBBox
														className="d-flex flex-column justify-content-center stock-description">
														<MDBTypography tag="p"
														               className="politician-name ">{item.name}</MDBTypography>
														<MDBBox
															className="d-flex align-items-center justify-content-between">
															<MDBTypography tag="p"
															               className="party-name ">{item.party_name}</MDBTypography>
															{/*stockOwnedcount change */}
															{stockOwnedCount > 0 && <hr className="horizontal-line"/>}
															{stockOwnedCount > 0 && <MDBTypography tag="p"
															                                       className="stock-count">{stockOwnedCount}</MDBTypography>}
															{stockOwnedCount > 0 && <MDBTypography tag="p"
															                                       className="stock-text">{stockOwnedCount > 1 ? " Shares " : " Share "} owned</MDBTypography>}
														</MDBBox>
													</MDBBox>
												</MDBBox>
												<MDBBox>
													<MDBTypography tag="p"
													               className="stock-price">₹ {item.price}</MDBTypography>
													{!item.upcoming &&
													<MDBBox className="d-flex  justify-content-end align-items-center">
														{
															priceDiff >= 0 ?
																<img alt={"alt"} src={caretUp}
																     style={{width: "8px", height: "5px"}}/> :
																<img alt={"alt"} src={caretDown}
																     style={{width: "8px", height: "5px"}}/>

														}
														<MDBTypography tag="p" className="party-stock-value"
														               style={{color: priceDiffPercentage >= 0 ? profit_color : loss_color}}
														>
															{priceDiffPercentage ? priceDiffPercentage : 0}%
														</MDBTypography>
													</MDBBox>
													}
												</MDBBox>
											</MDBBox>
											<div className={"horizontal-divider"}/>
											{/*</Reveal>*/}
										</Link>
										:

										<Link to={"/stock-detail/" + (item.node.id)} key={index}>
											{/*<Reveal effect="zoomIn fadeInUp">*/}
											<MDBBox className="d-flex justify-content-between align-items-center">
												<MDBBox className="d-flex align-items-center">
													<MDBBox className="politician-profile">
														<img
															src={item.node && item.node.politicianImage ? item.node.politicianImage : ProfileIcon}
															alt="politician1" className="img-fluid"
															style={{
																width: "40px",
																height: "40px",
																objectFit: "contain"
															}}/>
													</MDBBox>
													<MDBBox
														className="d-flex flex-column justify-content-center stock-description">
														<MDBTypography tag="p"
														               className="politician-name ">{item.node.name}</MDBTypography>
														<MDBBox
															className="d-flex align-items-center justify-content-between">
															<MDBTypography tag="p"
															               className="party-name ">{item.node.party.partyName}</MDBTypography>
															{/*stockOwned change*/}
															{stockOwnedCount > 0 && <hr className="horizontal-line"/>}
															{stockOwnedCount > 0 && <MDBTypography tag="p"
															                                       className="stock-count">{stockOwnedCount}</MDBTypography>}
															{stockOwnedCount > 0 && <MDBTypography tag="p"
															                                       className="stock-text">{stockOwnedCount > 1 ? " Shares " : " Share "} owned</MDBTypography>}
														</MDBBox>
													</MDBBox>
												</MDBBox>
												<MDBBox>
													<MDBTypography tag="p"
													               className="stock-price">₹ {item.node && item.node.price}</MDBTypography>

													<MDBBox className="d-flex  justify-content-end align-items-center">
														{
															priceDiff >= 0 ?
																<img alt={"alt"} src={caretUp}
																     style={{width: "8px", height: "5px"}}/> :
																<img alt={"alt"} src={caretDown}
																     style={{width: "8px", height: "5px"}}/>

														}
														<MDBTypography tag="p" className="party-stock-value"
														               style={{color: priceDiffPercentage >= 0 ? profit_color : loss_color}}
														>
															{priceDiffPercentage ? priceDiffPercentage : 0}%
														</MDBTypography>
													</MDBBox>

												</MDBBox>
											</MDBBox>
											<div className={"horizontal-divider"}/>
											{/*</Reveal>*/}
										</Link>
							);
						})
						: <div className={"error-section"}>No Datas Found</div>
				}
			</MDBBox>
		);
	}
}

export default withRouter(StockList);

